import { updateOtpCountAction } from 'components/Login/actions';
import { GIVEN_NAME, MESSAGE_MFA_CHANNEL, PROMPT_OTP } from 'components/Login/constants';
import { getCallbackOfTypeSafely, getCallbackWithIdSafely, getCallbackWithPromptSafely } from '../authTreeUtils';
import executeHiddenCallbackForUserContextRetrieval from './executeHiddenCallbackForUserContextRetrieval';
import nextStep from './handleStep';
import { CallbackType, FRWebAuthn, StepType, WebAuthnStepType } from '@forgerock/javascript-sdk';
import successRedirection from './common/successRedirection';
import { decideViewAfterOTPadd } from './otpAsyncAction';

const otpChannelSelectionAsyncAction = async (dispatch, payload) => {
  const { stage, otpchannel, history, gotoURI, locale, realm, brand } = payload;
  const choiceCallback = getCallbackWithPromptSafely(stage, MESSAGE_MFA_CHANNEL);

  if (choiceCallback) {
    dispatch(updateOtpCountAction(0));
    choiceCallback.setChoiceIndex(otpchannel);
    try {
      let step = await nextStep(dispatch, stage);
      const webAuthnStep = FRWebAuthn.getWebAuthnStepType(step);
      if (webAuthnStep === WebAuthnStepType.Authentication) {
        // Authenticate with a registered device
        step = await FRWebAuthn.authenticate(step);
        step = await nextStep(dispatch, step);
        if (
          getCallbackOfTypeSafely(step, CallbackType.TextOutputCallback) &&
          getCallbackWithIdSafely(step, GIVEN_NAME)
        ) {
          step = await executeHiddenCallbackForUserContextRetrieval(dispatch, step);
        }
        if (step.type === StepType.LoginSuccess) {
          successRedirection(dispatch, { finalStep: step, history, gotoURI, locale, realm, brand });
        } else {
          decideViewAfterOTPadd(dispatch, step, history);
        }
      } else {
        const secondStep = await executeHiddenCallbackForUserContextRetrieval(dispatch, step);
        // need to check for passkey flows here
        if (getCallbackWithPromptSafely(secondStep, PROMPT_OTP)) {
          history.push('/otp');
        }
        sessionStorage.setItem('ciam.backButton-otp', JSON.stringify(secondStep));
      }
    } catch (error) {
      throw error;
    }
  }
};

export default otpChannelSelectionAsyncAction;
